import HeroSection from "../heroSection/HeroSection";
import TransportForm from "../heroSection/TransportForm";
import heroPhoto from "../../assets/images/hero-bg3.jpg";
import TransportPage from "../tansportPage/TransportPage";
import ExpressSectionTransport from "../expressSectionTransport/ExpressSectionTransport";
import ServiceSection from "../serviceSection/ServiceSection";
import TransportHomeSection from "../transportHomeSection/TransportHomeSection";
import TransportHomeImage from "../transportHomeImage/TransportHomeImage";
import TestimonialsSection from "../testimonialsSection/TestimonialsSection";
import FeatureCardsSection from "../featureCardsSection/FeatureCardsSection";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import SEO from "../SEO";
import TransportTypesPage from "../transportTypesPage/TransportTypesPage";

export default function HomeTransport() {
  const { t } = useTranslation();
  const [selectedTransport, setSelectedTransport] = useState(null);
  const [autoOpenTransportSelector, setAutoOpenTransportSelector] =
    useState(false);
  const transportFormRef = useRef(null);

  useEffect(() => {
    let hasUserMoved = false;
    let modalTimeoutId;

    const markUserMoved = () => {
      hasUserMoved = true;
    };

    const timeoutId = window.setTimeout(() => {
      if (hasUserMoved || window.scrollY > 10) return;

      transportFormRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      modalTimeoutId = window.setTimeout(() => {
        if (!hasUserMoved) {
          setAutoOpenTransportSelector(true);
        }
      }, 500);
    }, 1200);

    window.addEventListener("wheel", markUserMoved, { passive: true });
    window.addEventListener("touchmove", markUserMoved, { passive: true });
    window.addEventListener("keydown", markUserMoved);

    return () => {
      window.clearTimeout(timeoutId);
      window.clearTimeout(modalTimeoutId);
      window.removeEventListener("wheel", markUserMoved);
      window.removeEventListener("touchmove", markUserMoved);
      window.removeEventListener("keydown", markUserMoved);
    };
  }, []);

  return (
    <>
      <SEO
        title="TransCirox – Paletten & Gütertransport | Transport Service Deutschland"
        description="Palettentransport, Stückgut und Gütertransport schnell und günstig buchen. TransCirox bietet zuverlässigen Transport für Unternehmen und Privatkunden in ganz Deutschland."
        keywords="Palettentransport, Palettenversand, Europalette Transport, Stückgut Transport, Frachttransport, Gütertransport, Spedition Paletten, Transport günstig, Transport Preise, Logistik Deutschland, Express Transport"
      />
      <HeroSection
        backgroundImage={heroPhoto}
        title={t("HomeTransport.hero.title")}
        titleHighlight={t("HomeTransport.hero.titleHighlight")}
        features={[
          t("HomeTransport.hero.features.feature1"),
          t("HomeTransport.hero.features.feature2"),
          t("HomeTransport.hero.features.feature3"),
        ]}
        showQuoteForm={false}
        showUmzugNavbar={true}
        showNavbar={false}
        formType="transport"
        formComponent={
          <div ref={transportFormRef}>
            <TransportForm
              selectedTransport={selectedTransport}
              setSelectedTransport={setSelectedTransport}
              autoOpenTransportSelector={autoOpenTransportSelector}
            />
          </div>
        }
      />

      <TransportTypesPage />
      <FeatureCardsSection />
      <TransportPage />
      <ExpressSectionTransport />
      <ServiceSection showOnlyLast={true} />
      <TransportHomeSection />
      <TransportHomeImage />
      <TestimonialsSection />
    </>
  );
}
